export default {"src":"/_next/static/media/MoreAction.cea37748.svg","height":12,"width":4};